// extracted by mini-css-extract-plugin
export default {"device":"index_device__SSj0f","box":"index_box__NMKNb"};